import styled from 'styled-components';
import { Popover } from '../../../popovers';

export const RequestAssigneesWrapper = styled(Popover)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: ${({ assigneesLenght }) => assigneesLenght === 1 ? '0' : '20px'};
`;



// WEBPACK FOOTER //
// ./src/components/requests-list-item/request-header/request-assignees/styled-components.js